import React, { useState } from 'react';
import {
  Image,
  Linking,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import { ODSText } from '../../atoms/ODSText';
import { ODSIcon } from '../../atoms/ODSIcon';
import { useTheme } from '@emotion/react';
import ODSButton from '../../atoms/ODSButton';


const HousingGatewayCard = ({
  hasBorder = false,
  housingGatewayPressed = null
}) => {
  const { colors } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const hoverProps = Platform.OS === 'web' ? {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  } : {};

  return (
    <View
      style={[
        styles(colors).containerStyle,
        isHovered && styles(colors).containerHover,
      ]}
      {...hoverProps}
    >
      <ODSText type='md-bold' color={colors.main.pink[500]}>My Housing Issue Gateway</ODSText>
      {!hasBorder && <Image source={require('../../../images/logos/tds-charity.png')} style={{ width: 102, height: 38, marginTop: 20 }} />}
      <ODSText type='h6' marginVertical={20} textAlign='left' color={colors.text.black}>Need help resolving a tenancy related issue?</ODSText>
      <ODSText type='sm' marginBottom={20} textAlign='left' color={colors.text.primary}>This free-to-use platform was developed by the TDS Charitable Foundation to help tenants navigate the complex solutions and organisations in place for resolving rental issues.</ODSText>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        {hasBorder && <Image source={require('../../../images/logos/tds-charity.png')} style={{ width: 86, height: 32, marginRight: 50 }} />}
        <ODSButton
          type="primary"
          disabled={false}
          themeColor={colors.main.pink}
          onPress={() => {
            housingGatewayPressed && housingGatewayPressed();
            Linking.openURL('https://www.myhousinggateway.org.uk/?utm_source=tlyfe&utm_medium=app&utm_campaign=tlyfe+-+referral+-+my+housing+gateway+-+website+link')
          }}>
          Access here
        </ODSButton>
      </View>
    </View>
  );
};

const styles = (theme) =>
  StyleSheet.create({
    containerStyle: {
      flex: 1,
      paddingVertical: 32,
      paddingHorizontal: 28,
      backgroundColor: theme.main.pink[100],
      borderRadius: 16,
      borderLeftWidth: 4,
      borderLeftColor: theme.main.pink[500],
      shadowColor: '#0F172A',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.04,
      shadowRadius: 8,
      elevation: 2,
      ...(Platform.OS === 'web' ? {
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      } : {}),
    },
    containerHover: {
      shadowOpacity: 0.08,
      shadowRadius: 16,
      shadowOffset: { width: 0, height: 4 },
      ...(Platform.OS === 'web' ? {
        transform: [{ translateY: -2 }],
      } : {}),
    },
    hasBorder: {
      borderWidth: 1, borderRadius: 12,
      borderColor: '#001B9C'
    }
  });

export default HousingGatewayCard;
